/**
 * This is the account module configuration.
 * Do NOT configure routes in this file.
 * @memberOf Account Module
 * @namespace Account Config
 */

/**
 * @name config
 * @desc Configures the module.
 * @memberOf Account Module.Account Config
 * @ngInject
 */
var config = function () {
}

export default config;


// WEBPACK FOOTER //
// ./src/login/account/account.config.js